
<template>
    <div class="testimonial-list uk-container uk-container-small">        
        <div class="line-break">
            <SquareLineBreak class="yellow"></SquareLineBreak>
        </div>
        <swiper :options="swiperTestimonials" class="swiper--testimonials swiper-container" ref="swiperTestimonials">
            <swiper-slide v-for="(slide, i) in data" :key="slide.sys.id" class="swiper-slide">
                <TestimonialItem
                    :fields="slide.fields"
                    :sys="slide.sys">
                </TestimonialItem>
            </swiper-slide>
            <!-- Pagination -->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
 
<script>
import TestimonialItem from '@/components/TestimonialItem'
import SquareLineBreak from '@/assets/img/sq-linebreak.svg'

export default {
    props: ['data'],
    components: {
        TestimonialItem,
        SquareLineBreak
    },
    data () {
        return {
            swiperTestimonials: {
                direction: 'horizontal',
                loop: true,
                autoplay: {
                    delay: 15000,
                    disableOnInteraction: false,
                },
                speed: 3000,
                slidesPerView: 'auto',
                spaceBetween: 100,
                grabCursor: true,
                simulateTouch: true,
                // Pagination
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    }
}
</script>

<style lang="scss">

    .testimonial-list.uk-container {
        max-width: 760px; // reduced from 900px
        @include mq($from: xlarge) {  
            max-width: 58vw;
        }
        
        .swiper--testimonials {
            @include handCursor();
        }
    }

    .line-break {
        width: 120px;
        margin: 20px auto;
        
        @include mq($from: medium) {
            margin: 30px auto;
        }
    }

    .swiper-pagination {
        position: relative;
        bottom: 0 !important;
    }
    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        border: 2px solid $yellow;
        opacity: 1;

        @include mq($from: desktop) {
            width: get-vw(8px);
            height: get-vw(8px);
            border: get-vw(2px) solid $yellow;
        }

        &.swiper-pagination-bullet-active {
            background: $yellow;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/TestimonialList.vue